import XmarkCircle from './XmarkCircle';

export default XmarkCircle;
